import { Group } from "three";
import { Main } from "../Main";
import { SimpleSignal } from "../utils/SimpleSignal";
import { GLTFLoader, GLTF } from "three/examples/jsm/loaders/GLTFLoader.js";

export class AssetLoader
{

	public loadedSignal = new SimpleSignal();

	public result: Group;

	private _loader: GLTFLoader;

	constructor()
	{
		this.loadedSignal = new SimpleSignal();
	}

	public load(path:string, onLoaded?: (result: Group) => void)
	{
		if (onLoaded)
		{
			this.loadedSignal.add(onLoaded);
		}

		this._loader = new GLTFLoader();
		this._loader.load(path, this.onLoaded);
	}

	private onLoaded = (result: GLTF) =>
	{
		this.result = result.scene;

		this.loadedSignal.dispatch(result.scene, this);

		Main.getInstance().render = true;
	};
}
